// Published legal documents live on the Argo corporate site, not in this
// portal — the portal never hosts legal copy, so there is nothing here to keep
// in sync when Legal revises a document.
//
// These are plain constants rather than runtime config (GET /api/config)
// because the URLs are identical in every lane; there is no per-lane value for
// a lane-agnostic build to freeze.

export const PRIVACY_POLICY_URL = 'https://argoshipping.com/privacy-policy/';
export const TERMS_URL = 'https://argoshipping.com/terms-and-conditions/';
export const COOKIE_POLICY_URL = 'https://argoshipping.com/cookie-policy/';
